const _excluded = ["tabIndex", "onFocus", "onBlur", "className", "children", "size", "error", "disabled", "readOnly"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../../view-model";
import { multiRef } from '@isyc-react/core/utils/reference';
import "./input-decorators.style.scss";
export const InputDecoratorsContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      tabIndex = -1,
      onFocus,
      onBlur,
      className,
      children,
      size,
      error,
      disabled,
      readOnly
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [focused, setFocused] = React.useState(false);
  const containerRef = React.useRef(null);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: multiRef(ref, containerRef),
    className: clsx('input-decorators', className, {
      'decorators-sm': size === FormSize.SM,
      'decorators-lg': size === FormSize.LG,
      'decorators-xl': size === FormSize.XL,
      readOnly,
      disabled,
      error,
      focused
    }),
    tabIndex: tabIndex,
    onFocus: e => {
      if (!disabled && !readOnly) {
        setFocused(true);
        onFocus && onFocus(e);
      }
    },
    onBlur: e => {
      if (!disabled && !readOnly) {
        const relatedTarget = e.relatedTarget;
        if (containerRef.current && relatedTarget) {
          if (!containerRef.current.contains(relatedTarget)) {
            setFocused(false);
            onBlur && onBlur(e);
          }
        } else {
          setFocused(false);
          onBlur && onBlur(e);
        }
      }
    }
  }, rest), children);
});